import { CancelSubmitButtons } from "~/common/components";
import Modal, { ModalProps } from "~/common/components/Modal";

interface VerifyPhoneNumberModalProps extends ModalProps {
  onVerify: () => void;
}

export const VerifyPhoneNumberModal = ({
  children,
  onVerify,
  ...props
}: VerifyPhoneNumberModalProps) => {
  return (
    <Modal {...props} title="Verify your mobile number">
      {children}
      <CancelSubmitButtons
        handleCancel={props.onClose}
        handleSubmit={onVerify}
        submitButtonLabel="Verify"
      />
    </Modal>
  );
};
